'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
# CopyUrlSVG
An SVG CopyUrl icon
 */
var CopyUrlSVG = function CopyUrlSVG(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? undefined : _ref$color,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? undefined : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? undefined : _ref$width;
  return _react2.default.createElement(
    'svg',
    {
      'aria-label': 'CopyUrl',
      role: 'img',
      height: height || undefined,
      width: width || undefined,
      viewBox: '0 0 108.17 94.17',
      xmlns: 'http://www.w3.org/2000/svg'
    },
    _react2.default.createElement(
      'g',
      {
        id: 'copyUrl',
        fill: color,
        fillRule: 'nonzero',
        transform: 'translate(0.000000,87.000000) scale(0.400000,-0.400000)'
      },
      _react2.default.createElement('path', { d: 'M89.05 0a89.09 89.09 0 1 0 89.12 89.12A89.12 89.12 0 0 0 89.05 0ZM102 115.25c0 .06 0 .06-.06.06L89.71 127.56a27.62 27.62 0 0 1-39-39.1l6.68-6.68a2.89 2.89 0 0 1 5 1.9 34.4 34.4 0 0 0 1.76 9.56 2.84 2.84 0 0 1-.65 3L61 98.68a13.08 13.08 0 1 0 18.4 18.59L91.61 105a13.06 13.06 0 0 0 0-18.47A18.33 18.33 0 0 0 89.77 85a3.2 3.2 0 0 1-1.31-2.29 7.3 7.3 0 0 1 2.16-5.37l3.8-3.86a3 3 0 0 1 3.73-.33 36.09 36.09 0 0 1 3.74 3.14A27.53 27.53 0 0 1 102 115.25Zm25.54-25.54-6.74 6.74a2.91 2.91 0 0 1-5-1.9 32.33 32.33 0 0 0-1.7-9.56 2.85 2.85 0 0 1 .65-3l2.36-2.42A13.06 13.06 0 1 0 98.74 61L86.5 73.14a13.12 13.12 0 0 0 0 18.53 23 23 0 0 0 1.9 1.57 3.13 3.13 0 0 1 1.24 2.3 7.17 7.17 0 0 1-2.09 5.36l-3.87 3.87a3 3 0 0 1-3.73.33c-1-.79-2.75-2.23-3.73-3.15a27.65 27.65 0 0 1-.07-39l.07-.06L88.46 50.68a27.6 27.6 0 0 1 39 39Z' })
    )
  );
};

CopyUrlSVG.propTypes = {
  /** a color for the icon */
  color: _propTypes2.default.string,
  /** height for the SVG. Can be px, rem, percentage, etc. */
  height: _propTypes2.default.string,
  /** width for the SVG. Can be px, rem, percentage, etc. */
  width: _propTypes2.default.string
};

CopyUrlSVG.displayName = 'CopyUrlSVG';

exports.default = CopyUrlSVG;
CopyUrlSVG.__docgenInfo = {
  'description': '# CopyUrlSVG\r\nAn SVG CopyUrl icon',
  'methods': [],
  'displayName': 'CopyUrlSVG',
  'props': {
    'color': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'a color for the icon'
    },
    'height': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'height for the SVG. Can be px, rem, percentage, etc.'
    },
    'width': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'width for the SVG. Can be px, rem, percentage, etc.'
    }
  }
};